import { createAxios } from "./axiosHttpMarconi";

export const solucionesService = {
  getSoluciones,
  deleteSolucion,
  postSolucion,
  updateSolucion,
  getSolucionById,
  getSolucionesExcel,
};

function getSoluciones(pagination, filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/soluciones`;
  if (pagination) {
    urlPath += `?page=${pagination.currentPage - 1}&limit=${
      pagination.perPage
    }`;
  } else {
    urlPath += "?page=0";
  }
  urlPath += getUrlPath(filters);
  return axios.get(urlPath);
}

function getSolucionesExcel(filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/soluciones/excel?limit=2000`;
  urlPath += getUrlPath(filters);
  return axios.get(urlPath, { responseType: "blob" });
}

function getUrlPath(filters) {
  let urlPath = "";
  if (filters && filters.descripcion) {
    urlPath += `&descripcion=${filters.descripcion}`;
  }
  if (filters && filters.codigo) {
    urlPath += `&codigo=${filters.codigo}`;
  }
  return urlPath;
}

function deleteSolucion(sulucionId) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/soluciones/${sulucionId}`;
  return axios.delete(urlPath);
}

function postSolucion(request) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/soluciones`;
  return axios.post(urlPath, request);
}

function updateSolucion(id, body) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/soluciones/${id}`;
  return axios.put(urlPath, body);
}
function getSolucionById(id) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/soluciones/${id}`;
  return axios.get(urlPath);
}
